/**
 * Notifications API client — the in-app billing/account alert feed.
 *
 * Backend contract (backend/notifications/router.py):
 *   GET  /notifications           → { items, unread_count }
 *   POST /notifications/{id}/read → { updated }
 *   POST /notifications/read-all  → { updated }
 *
 * Strictly personal: the backend scopes every query to the caller's
 * user_id, so there's no scope parameter here.
 */
import apiClient from "@lib/axios";

export type NotificationKind =
  | "payment_failed"
  | "payment_recovered"
  | "low_balance"
  | "balance_depleted"
  | string;

export interface ServerNotification {
  id: string;
  kind: NotificationKind;
  title: string;
  body: string;
  action_url?: string | null;
  action_label?: string | null;
  read_at?: string | null;
  created_at?: string | null;
}

export interface NotificationListResponse {
  items: ServerNotification[];
  unread_count: number;
}

export const notificationsApi = {
  list: async (): Promise<NotificationListResponse> => {
    const { data } =
      await apiClient.get<NotificationListResponse>("/notifications");
    return data;
  },
  markRead: async (id: string): Promise<void> => {
    await apiClient.post(`/notifications/${id}/read`);
  },
  markAllRead: async (): Promise<void> => {
    await apiClient.post("/notifications/read-all");
  },
};
